import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  scheduleEvent: null,
};

export const scheduleEventSlice = createSlice({
  name: "scheduleEvent",
  initialState,
  reducers: {
    setScheduleEvent(state, { payload }) {
      state.scheduleEvent = payload;
    },
    updateScheduleEvent(state, { payload }) {
      state.scheduleEvent = {
        ...state.scheduleEvent,
        ...payload,
      };
    },
    clearScheduleEvent(state) {
      state.scheduleEvent = null;
    },
    updateScheduleEventPatientSurgery(state, { payload }) {
      const { patientSurgery, scheduleEvent } = payload;

      state.scheduleEvent = {
        ...state.scheduleEvent,
        ...scheduleEvent,
        patientSurgery: {
          ...state.scheduleEvent.patientSurgery,
          ...patientSurgery,
        },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setScheduleEvent,
  updateScheduleEvent,
  clearScheduleEvent,
  updateScheduleEventPatientSurgery,
} = scheduleEventSlice.actions;
